import { css, keyframes } from '@emotion/react';

const flicker = keyframes`
  0% { opacity: 1; }
  20% { opacity: 0; }
  80% { opacity: 0; }
`;

export default css`
  g {
    animation: ${flicker} 1500ms linear infinite;

    &:nth-of-type(1) { animation-delay: 0ms; }
    &:nth-of-type(2) { animation-delay: -300ms; }
    &:nth-of-type(3) { animation-delay: -600ms; }
    &:nth-of-type(4) { animation-delay: -900ms; }
    &:nth-of-type(5) { animation-delay: -1200ms; }
  }
    path {
      fill: white;
    }
`;